import { countries } from '../countries'

export const countriesOptions: { value: string; label: string }[] = Object.keys(countries).map((key) => ({
  label: countries[key as keyof typeof countries],
  value: key,
}))
